// Simulador de financiamento EXTERNO por site (codsite -> URL do parceiro). Quando o
// site está listado aqui, os CTAs de "Simular Financiamento" da home abrem o link do
// parceiro em vez do simulador interno (modal / página /simulador).
export const SITE_EXTERNAL_SIMULATOR_URLS: Record<number, string> = {
    2603: 'https://simular.credihome.com.br/casabrancabank',
};

export const resolveExternalSimulatorUrl = (site: any) =>
    SITE_EXTERNAL_SIMULATOR_URLS[Number(site?.id)] ?? '';

export const openExternalSimulator = (url: string) => {
    if (typeof window === 'undefined' || !url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
};
